import React, {useState} from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {EVehicleTypeField} from "./EVihicleType";

const MerchantGroupFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

function ImageWithFallback({record = {}}) {
    const [error, setError] = useState(false);

    const onClick = (e) => {
        e.stopPropagation()
        window.open(record.vehicleImagePath, "_blank", "noopener,noreferrer");
    }
    if (error) {
        return <button
            onClick={onClick}
            style={{
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            color: "blue",
            cursor: "pointer",
            font: "inherit"
        }}>Hiển thị hình</button>;
    }

    return (
        <img
            src={record.vehicleImagePath}
            alt={record.name}
            onError={() => setError(true)}
            style={{maxHeight: '10rem'}}
        />
    );
}

export const ParkingVehicleList = props => (
    <List filters={<MerchantGroupFilter/>} {...props} exporter={false}>
        <Datagrid rowClick={"edit"}>
            <TextField source="customerId"/>
            <TextField source="name"/>
            <EVehicleTypeField source="vehicleType"/>
            <ImageWithFallback label={'Hình xe'}/>
        </Datagrid>
    </List>
);

export default ParkingVehicleList
